"use client";
import { useState } from "react";

interface FaqItem {
  question: string;
  answer: string;
}

export function ServiceFaq({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  if (!items || items.length === 0) return null;

  return (
    <section className="bg-[#f2f4f7] py-16 sm:py-20 md:py-[7.5rem]">
      <div className="mx-auto max-w-4xl px-5 sm:px-6">
        <h2 className="text-2xl font-bold leading-tight text-[#202333] sm:text-3xl md:text-4xl">
          Frequently Asked Questions
        </h2>
        <div className="mt-8 space-y-3 sm:mt-10">
          {items.map((item, i) => {
            const open = openIndex === i;
            return (
              <div
                key={i}
                className="overflow-hidden rounded-2xl border border-[#eef0f4] bg-white"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-base font-semibold text-[#202333] sm:text-lg"
                >
                  <span>{item.question}</span>
                  <span
                    className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#eef1ff] text-[#425ef9]"
                    aria-hidden
                  >
                    {open ? "−" : "+"}
                  </span>
                </button>
                {open && (
                  <div className="border-t border-[#eef0f4] px-6 py-5 text-sm text-[#3b3c47] sm:text-base">
                    {item.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
